const routes = {
  opportunities: "/opportunities",
  dead_opps: "/dead_opps",
  bookings: "/bookings",
  skippings: "/skippings",
  suspends: "/suspends",
  planner_stats: "/planner_stats",
  platform_stats: "/platform_stats",
  magic: "/magic",
  signin: "/signin",
  root: "/",
};
routes.DEFAULT = routes.opportunities;
export default routes;
